import { GoogleServiceLib } from '@lib/common';
import { config } from '../../config';

export const GoogleCreateService = GoogleServiceLib(config.services.google.api_key);
